import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IFileDownload, IExam, IResultReport } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';
import { Router, UrlSerializer } from '@angular/router';
import { DateTime } from 'luxon';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-exam-result',
  templateUrl: './exam-result.component.html',
  styleUrls: ['./exam-result.component.scss']
})
export class ExamResultComponent implements OnInit {

  exportedFile: IFileDownload = {
    fileName: '',
    size: 0,
    extension: '',
    file: undefined
  };
  exam: IExam = examDefault;
  resultReport: IResultReport = {
    examinationID: 0,
    writtenOnly: false,
    dateOfWriting: '',
    sortBy: '',
    includePassportPhoto: false,
    includeContactDetails: false,
    candidateNoList: '',
    cutOffScore: 0,
    cutOffPercentage: 0,
    skipImportCandidateData: false,
    faceMismatchFlagsThreshold: 0,
    multipleFacesFlagsThreshold: 0,
    noFaceFlagsThreshold: 0,
    noiseFlagsThreshold: 0,
    humanFlagsThreshold: 0,
    includeMalpracticeSuspicion: true,
    highScorePercentile: 0,
    highScorePercentage: 0,
    excludeTestCandidates: true
  }
  constructor(private popoverRef: PopoverRef<ExamResultComponent>,
    private examService: ExamService, private router: Router,
    private snackBar: SnackbarService, private serializer: UrlSerializer,) { }

  async ngOnInit() {
    if (this.examService.selectedExams?.length === 1) {
      this.exam = this.examService.selectedExams[0];
    }
  }

  close() {
    this.popoverRef.close();
  }

  async getResultReport() {
    this.resultReport.examinationID = this.exam.id;

    if (this.resultReport.sortBy == '') {
      this.resultReport.sortBy = "NotSet";
    }
    const reportTree = this.router.createUrlTree([], { queryParams: this.resultReport });

    let params = this.serializer.serialize(reportTree).split('?', 2)[1];
    await this.examService.getExamResultReport(params).then((s: any) => {
      this.snackBar.success('Report Successfull');
      this.exportedFile = s;
    }).catch((e) => {
      console.log(e);
    });

  }
}
